import { ITripPlace } from '../services/ApiService';

export function placeIsStop(place: ITripPlace) {
  return place.type === 'stop';
}

export function placeIsWaypoint(place: ITripPlace) {
  return place.type === 'waypoint';
}
